import { Button, Modal, Segment } from '@mairistem/composants';

import { formatMonetaire } from '@/utils';

export interface ModalEncaissementReglementPartielProps {
  disableRepartAuto?: boolean;
  multiple?: boolean;
  montant: number;
  total: number;
  nombreFacture: number;
  partiel: boolean;
  onClose: () => void;
  onSelect: (auto?: boolean) => void;
}

const ModalEncaissementReglementPartiel = (props: ModalEncaissementReglementPartielProps) => {
  const { disableRepartAuto, multiple, nombreFacture, montant, total, partiel, onClose, onSelect } =
    props;

  return (
    <Modal open closeIcon onClose={onClose} size="small">
      <Modal.Header>Règlement partiel</Modal.Header>
      <Modal.Content>
        <Segment basic style={{ padding: 0 }}>
          <span>
            {multiple
              ? `Vous avez enregistré plusieurs règlements pour un montant total de ${formatMonetaire(montant, 2, true)}.`
              : `Vous avez enregistré un règlement de ${formatMonetaire(montant, 2, true)}.`}
          </span>
          <br />
          <span>
            {`Cette somme ne permet pas l'acquittement complet ${partiel ? 'du reste à encaisser' : nombreFacture === 1 ? 'de la facture sélectionnée' : `des ${nombreFacture} factures sélectionnées`} (${formatMonetaire(total, 2, true)}).`}
          </span>
          <br />
          <br />
          <span>
            {`Répartissez ce montant entre ${nombreFacture === 1 ? 'les produits' : 'les factures et produits'} concernés :`}
          </span>
          <Segment
            basic
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: 0,
              marginBlock: '2em',
            }}
          >
            <div style={{ width: 320 }}>
              <Button
                data-testid="button-affectation-manuelle"
                basic
                fluid
                size="medium"
                style={{ padding: '1em' }}
                positive
                content="Répartition manuelle"
                onClick={() => onSelect()}
              />
            </div>
            <div
              style={{ width: 320 }}
              {...(disableRepartAuto && {
                title:
                  'Un règlement est incompatible avec la répartition automatique.\nUniquement les modes de règlements suivant sont compatibles : chèque, virement, et numéraire.',
              })}
            >
              <Button
                data-testid="button-affectation-auto"
                basic
                fluid
                style={{ padding: '1em' }}
                positive={!disableRepartAuto}
                content="Répartition automatique au prorata"
                onClick={() => onSelect(true)}
                disabled={disableRepartAuto}
              />
            </div>
          </Segment>
        </Segment>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          style={{ marginBottom: '1em' }}
          floated="left"
          size="tiny"
          content="Revenir à l'encaissement"
          onClick={onClose}
          icon="close"
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalEncaissementReglementPartiel;
